module.exports = __webpack_public_path__ + "img/team-wl.1729a54e.png";